// src/services/api/examExcel.js

import { BASE_URL } from "../../config";

export async function downloadExamExcelTemplate(token, examId) {
  const res = await fetch(`${BASE_URL}/exam/${examId}/excel/items-template`, {
    method: "GET",
    headers: {
      "x-access-token": token,
    },
  });

  if (!res.ok) {
    let msg = "دانلود اکسل ناموفق بود";
    try {
      const j = await res.json();
      msg = j?.message || msg;
    } catch {}
    throw new Error(msg);
  }

  return await res.blob();
}

export async function previewExcelImport(token, file) {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch(`${BASE_URL}/exam/import/preview`, {
    method: "POST",
    headers: {
      "x-access-token": token,
    },
    body: form,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data?.message || "Preview ناموفق بود");
  }
  return data;
}

export async function commitExcelImport(token, file) {
  const form = new FormData();
  form.append("file", file);

  const res = await fetch(`${BASE_URL}/exam/import/commit`, {
    method: "POST",
    headers: {
      "x-access-token": token,
    },
    body: form,
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    // backend ممکنه 422 بده با errors
    const err = new Error(data?.message || "Commit ناموفق بود");
    err.details = data;
    throw err;
  }
  return data;
}
